<template>
    <div class="memberList">
        <v-card class="cardWrap">
            <CardTitle title="予約状況照会（日付指定）" />
             <v-form ref="form" lazy-validation>
                <v-toolbar flat color="white" class="mt-1">
                    <div><v-text-field
                        class="mr-3 pt-4"
                        label="プレー日"
                        inputmode="tel"
                        type="tel"
                        placeholder="0000-00-00"
                        maxlength="10"
                        v-model="formatedPlayDate"
                        @focus="focusDate(playDate)"
                        @keyup.delete="deleteKeyUp($event)"
                        @keyup="playDate = formatDate(playDate)"
                        :rules="[rules.string_type,
                                 rules.format_date,
                                 rules.correct_date,
                                 rules.required]"
                    /></div>
                    <v-select
                        class="mr-3 pt-4"
                        :items="golfSelect"
                        item-value="golf_code"
                        item-text="golf_name"
                        v-model="golfCode"
                        label="ゴルフ場名"
                    ></v-select>
                    <v-btn
                        color="primary"
                        class="ml-5"
                        v-on:click="checkValidateSearch"
                        :disabled="btn[1].isActive"
                    >検索</v-btn>
                    <v-spacer></v-spacer>
                    <div>
                        <template v-if="allCourse">
                            <span>枠数：{{ all_total_cells }} 枠</span><br>
                            <span>予約組数：{{ all_total_reserve }} 組</span><br>
                            <span>予約人数：{{ all_total_player }} 人</span>
                        </template>
                        <template v-else>
                            <span>枠数：{{ total_cells[courseFilter] }} 枠</span><br>
                            <span>予約組数：{{ total_reserve[courseFilter] }} 組</span><br>
                            <span>予約人数：{{ total_player[courseFilter] }} 人</span>
                        </template>
                    </div>
                </v-toolbar>
            </v-form>
            <v-data-table
                :headers="headers"
                :items="desserts"
                hide-default-footer
                class="elevation-1"
                sort-by="play_date"
                height="700"
                fixed-header
                disable-pagination
                :search="courseFilter"
                :custom-filter="filterOnlyCapsText"
            >
                <template v-slot:[`header.course_name`]="{ header }">
                    <div :class="{
                        'd-block': allCourse,
                        'd-none': !allCourse
                    }">{{ header.text }}</div>
                </template>
                <template v-slot:top>
                    <div class="d-flex">
                        <div
                            :key="item.course_name"
                            v-for="item in courseInSelectBox"
                            class="text-center tabWidth"
                            :class="{ 'border-bottom-tab': currentCourse(item) }"
                            >
                            <input
                                type="radio"
                                :id="`tab-${item.course_name}`"
                                class="d-none"
                                :checked="currentCourse(item)"
                                >
                            <label
                                :for="`tab-${item.course_name}`"
                                class="pa-2 courseTab"
                                :class="{ 'activeTab': currentCourse(item) }"
                                @click="clickTab(item.course_name, $event)"
                                >{{ item.course_name }}</label>
                        </div>
                    </div>
                </template>
                <template v-slot:[`item.course_name`]="{ item }">
                    <div :class="{
                        'd-block': allCourse,
                        'd-none': !allCourse
                    }">{{ item.course_name }}</div>
                </template>
                <template v-slot:[`item.detail`]="{ item }">
                    <v-btn
                        text
                        color="primary"
                        v-if="item.reserve_no"
                        @click="openModal(item)"
                        :disabled="btn[2].isActive"
                    >詳細
                    </v-btn>
                </template>
                <template v-slot:[`item.visitor_number`]="{ item }">
                    <v-select v-if="item.visitor_number!==false"
                        class="selectWidth"
                        :items="playerNmberList"
                        item-value="code"
                        item-text="code_name"
                        v-model="item.visitor_number"
                        @change="changeUpdateFlag"
                    />
                </template>
            </v-data-table>
            <ReserveDetailModal
                ref="Modal"
                :detailInfo="detailInfo"
                :adminInfo="admin"
                :golfCourseSelection="golfSelect"
                @refresh-event="getCells">
            </ReserveDetailModal>
            <RequestDetailModal
                ref="RequestModal"
                :detailInfo="detailInfo"
                :adminInfo="admin"
                :golfCourseSelection="golfSelect"
                @refresh-event="getCells">
            </RequestDetailModal>
        </v-card>
    </div>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
import validater from '../../lib/validater';
// モーダル
import ReserveDetailModal from './modal/ReserveDetail';
import RequestDetailModal from './modal/ReserveRequestDetail';

// graphql
import { GET_CODE_LIST_WITH_DEFAULT } from '@/constants/codelist';
import { golfCourseMixin } from '@/mixins/golfCourse';
import { codeListMixin } from '@/mixins/codeList';
import { authorityMixin } from '@/views/authorityMixin';
import { GET_RESERVE_LIST_BY_DAY, GET_RESERVE_TOTAL_CALC } from '@/constants/reserve';
import { GET_COURSE_LIST } from '@/constants/plan';
import { utilityMixin } from '@/mixins/utility';

export default {
    components: {
        CardTitle,
        ReserveDetailModal,
        RequestDetailModal
    },
    mixins: [
        authorityMixin,
        utilityMixin,
        golfCourseMixin,
        codeListMixin
    ],
    props: ['name'],
    data () {
        return {
            // モーダルウィンドウの状態
            changeOverlay: false,
            moveDisplay: false,
            updateFlag: false,
            dialog: false,
            processing: false,
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [
                { text: '時間', sortable: false, value: 'play_start' },
                { text: 'コース', sortable: false, value: 'course_name' },
                { text: 'プラン名', value: 'plan_name', sortable: false },
                { text: '予約種別', value: 'reserve_type_name', sortable: false },
                { text: '予約状況', align: 'center', value: 'reserve_situation_name', sortable: false },
                { text: '代表者', align: 'center', value: 'full_name', sortable: false },
                { text: '人数', align: 'center', value: 'player_number', sortable: false },
                { text: '詳細', align: 'center', value: 'detail', sortable: false }
            ],
            // データ格納用
            total_cells: [],
            total_reserve: [],
            total_player: [],
            moveToPage: '',
            playDate: '',
            result: '',
            resultText: '',
            originalData: [],
            courseInSelectBox: [],
            courseFilter: '',
            playerNmberList: [],
            // ログインしている者の情報
            admin: {
                user_id: '',
                user_div: '',
                golf_code: ''
            },
            // 処理結果
            process: {
                result: '',
                resultText: ''
            },
            // エラーメッセージ
            error: '',
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: '詳細', isActive: true }
            ],
            vue_id: 'SCR0013',
            golfSelect: [],
            golfCode: '',
            detailInfo: {
                reserve_no: '',
                member_no: '',
                dialog: true
            },
            all_total_cells: 0,
            all_total_reserve: 0,
            all_total_player: 0,
            rules: {
                string_type: value => validater.checkDateStringType(value) || this.$t('error.validation.num'),
                format_date: value => validater.checkDateFormat(value) || this.$t('error.validation.date.Correct'),
                correct_date: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct'),
                required: value => validater.checkEmptyString(value) || this.$t('error.validation.required.any')
            },
            // 検索処理中フラグ
            searchProcessing: false
        };
    },
    async created () {
        this.$store.commit('loading/setIsLoading', true);
        this.admin = await this.getLoginAdmin();
        this.golfSelect = await this.getGolfCourseList();
        this.golfCode = this.golfSelect[0].golf_code;
        this.playerNmberList = await this.getCodeListWithDefault('play_number', '0人');
        if (!this.$store.state.reserve.targetDate) {
            this.playDate = await this.getToday();
        } else {
            this.playDate = this.$store.state.reserve.targetDate;
            this.golfCode = this.$store.state.reserve.targetGolf;
        }
        await this.getReserveTotalCalc();
        await this.getCourseList();
        this.$nextTick(function () {
            this.courseFilter = this.courseInSelectBox[0].course_name;
        });
        await this.getAuthorityList();
        await this.getCells();
        this.searchProcessing = false;
        this.$store.commit('loading/setIsLoading', false);
    },
    beforeRouteLeave (to, from, next) {
        if (!this.updateFlag) {
            next();
        } else {
            this.moveToPage = to;
            this.moveDisplay = true;
        }
    },
    computed: {
        formatedPlayDate: {
            get () {
                return this.playDate;
            },
            set (value) {
                value = this.addHyphen(value);
                this.playDate = value;
            }
        },
        currentCourse () {
            return function (value) {
                return this.courseFilter === value.course_name;
            };
        },
        allCourse () {
            return this.courseFilter === '全て';
        }
    },
    methods: {
        /** --------------------------------------------
        * 予約数の合計を取得
        * -------------------------------------------- */
        async getReserveTotalCalc () {
            this.searchProcessing = true;
            this.total_cells = [];
            this.total_reserve = [];
            this.total_player = [];
            try {
                await this.$apollo.mutate({
                    mutation: GET_RESERVE_TOTAL_CALC,
                    variables: { playDate: this.playDate, golfGroupCode: process.env.VUE_APP_GROUP_CODE, golfCode: this.golfCode }
                }).then(res => {
                    // 「全て」の計算を初期化
                    this.all_total_cells = 0;
                    this.all_total_reserve = 0;
                    this.all_total_player = 0;
                    for (let totalCalcList of res.data.GetReserveTotalCalc.CalcList) {
                        this.total_cells[totalCalcList.course_name] = totalCalcList.total_cell;
                        this.total_reserve[totalCalcList.course_name] = totalCalcList.total_reserve;
                        this.total_player[totalCalcList.course_name] = totalCalcList.total_player;
                        this.all_total_cells += totalCalcList.total_cell;
                        this.all_total_reserve += totalCalcList.total_reserve;
                        this.all_total_player += totalCalcList.total_player;
                    };
                }).catch(error => {
                    this.result = 0;
                    this.error = error;
                });
            } catch (error) {
                this.error = error;
            }
        },
        getCodeListWithDefault (pramCodeKey, defaultDisplay) {
            return this.$apollo.mutate({
                mutation: GET_CODE_LIST_WITH_DEFAULT,
                variables: { code_key: pramCodeKey, default_display: defaultDisplay }
            }).then(res => {
                return res.data.GetCodeListWithDefault.CodeList;
            }).catch(error => {
                this.result = 0;
                this.error = error;
            });
        },
        /** --------------------------------------------
        * 枠場情報を取得
        * -------------------------------------------- */
        async getCells () {
            try {
                await this.$apollo
                    .mutate({
                        mutation: GET_RESERVE_LIST_BY_DAY,
                        variables: {
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            golf_code: this.golfCode,
                            target_date: this.playDate
                        }
                    })
                    .then(res => {
                        const data = res.data.getReserveListByDay.ReserveList;
                        data.forEach(ele => {
                            if (ele.visitor_number == null) {
                                ele.visitor_number = false;
                            } else {
                                ele.visitor_number = String(ele.visitor_number);
                                this.originalData[ele.reserve_no] = ele.visitor_number;
                            }
                        });
                        this.desserts = res.data.getReserveListByDay.ReserveList;
                    });
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * チェック処理
         * ---------------------------------------------- */
        checkValidateSearch () {
            if (this.$refs.form.validate()) {
                this.clickSearch();
            } else {
                return false;
            }
        },
        /** ----------------------------------------------
         * 検索処理
         * ---------------------------------------------- */
        async clickSearch () {
            /* 全てタグが増殖してしまうバグ対応
               検索処理中なら返す */
            if (this.searchProcessing) {
                return;
            }
            await this.getReserveTotalCalc();
            await this.getCourseList();
            this.$nextTick(function () {
                this.courseFilter = this.courseInSelectBox[0].course_name;
            });
            await this.getCells();
            this.searchProcessing = false;
        },
        /** ----------------------------------------------
         * プラン詳細を開く処理
         * ---------------------------------------------- */
        openModal (item) {
            this.detailInfo.reserve_no = item.reserve_no;
            this.detailInfo.member_no = item.member_no;
            this.dialog = true;
            if (item.reserve_type === 3) {
                this.$refs.RequestModal.openModal();
            } else {
                this.$refs.Modal.openModal();
            }
        },
        /** ----------------------------------------------
         * 当日の日付を取得
         * 例:2020-12-12
         * ---------------------------------------------- */
        getToday () {
            const today = new Date();
            const y = today.getFullYear();
            let m = today.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            let d = today.getDate();
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },
        /** --------------------------------------------
        * コースを取得
        *-------------------------------------------- */
        getCourseList () {
            return this.$apollo.query({
                query: GET_COURSE_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: this.golfCode
                }
            }).then(res => {
                const data = res.data.GetCoursesList;
                this.courseInSelectBox = [];
                data.unshift({ 'course_name': '全て', 'course_code': '' });
                this.courseInSelectBox = data;
            });
        },
        /** --------------------------------------------
        * タブをクリックした際の処理
        *-------------------------------------------- */
        clickTab (name, val) {
            this.courseFilter = name;
        },
        filterOnlyCapsText (value, search, item) {
            if (search !== '全て') {
                return value != null &&
                    search != null &&
                    typeof value === 'string' &&
                    value.toString().toLocaleUpperCase().indexOf(search) !== -1;
            } else {
                return true;
            }
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUp (event) {
            this.playDate = this.formatDate(this.playDate);
            this.playDate = this.deleteKeyDelete(event);
        }
    }
};
</script>

<style>
.selectWidth {
    width: 80px;
}
.activeTab{
    color: #1976d2 !important;
}
.border-bottom-tab{
    border-bottom: #1976d2 solid 1px;
    cursor: pointer;
}
.courseTab{
    display: block;
    cursor: pointer;
    width: 100%;
}
.tabWidth{
    width: 8%;
}
</style>
